import { useSearchParam } from 'components/search/search.hooks';
import debounce from 'lodash.debounce';
import { useEffect } from 'react';
import { useFocusFilter } from '../search-filters.hooks';
import IncTextInputBase, {
  IncTextFieldBaseProps,
} from 'components/forms/fields/inc-text-field/inc-text-input-base/inc-text-input-base.component';

type TextInputFilterProps = {
  searchParamName: string;
} & Partial<IncTextFieldBaseProps>;

export const TextInputFilter = ({
  searchParamName,
  ...rest
}: TextInputFilterProps) => {
  const {
    value,
    setValue,
    searchParam: {
      filter: { label, componentProps },
    },
    setFocus,
  } = useSearchParam<string>(searchParamName);
  const typedComponentProps =
    (componentProps as Partial<IncTextFieldBaseProps>) ?? {};
  const { ref } = useFocusFilter(setFocus);

  const inputElement = ref.current;

  useEffect(() => {
    const debounceSetValue = debounce(setValue, 500);

    const handleInput = e => {
      debounceSetValue((e.target as HTMLInputElement).value);
    };

    if (inputElement) inputElement.addEventListener('input', handleInput);

    return () => {
      if (inputElement) inputElement.removeEventListener('input', handleInput);
    };
  }, [inputElement, setValue]);

  return (
    <IncTextInputBase
      label={label}
      data-testid={`TextInputFilter.${searchParamName}`}
      ref={ref}
      variant="outlined"
      defaultValue={value}
      {...typedComponentProps}
      {...rest}
    />
  );
};

export default TextInputFilter;
